import { createAction } from 'redux-actions';
import FamilyMember from '../utils/FamilyMember/FamilyMember'


export const indexFamilyMember = createAction('INDEX_FAMILY_MEMBER',FamilyMember.index)
export const setIndexFamilyMember = createAction('SET_INDEX_FAMILY_MEMBER')
export const newFamilyMember = createAction('NEW_FAMILY_MEMBER',FamilyMember.new)
export const setNewFamilyMember= createAction('SET_NEW_FAMILY_MEMBER')
export const createFamilyMember = createAction('CREATE_FAMILY_MEMBER',FamilyMember.create)
export const destroyFamilyMember = createAction('DESTROY_FAMILY_MEMBER',FamilyMember.destroy)




// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/FamilyMemberAction.jsx